import React from 'react';
import {
  Box, Card, Typography, Tooltip
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import CloseIcon from '@mui/icons-material/Close';

const useStyles = makeStyles(() => ({
  searchbar: {
    width: '100%',
    paddingLeft: 24,
    paddingRight: 24,
    color: 'white',
  },
  itemList: {
    display: 'flex',
    justifyContent: 'flex-end',
    height: '100%',
  },
  item: {
    paddingTop: 10,
    paddingBottom: 10,
    width: '100%',
    color: 'white',
    flex: 0,
    textAlign: 'center',
    padding: '1rem',
    textDecoration: 'none',
    '&:hover': {
      background: 'rgba(255, 255, 255, 0.1)'
    }

  },
  active: {
    background: '#5850EC',
  }

}));

function NavBar() {
  const classes = useStyles();
  const account = useSelector((state) => state.account);
  const site = useSelector((state) => state.site);

  const adminNav = [
    {
      display: 'Users',
      link: '/admin/users'
    },
    {
      display: 'Roles',
      link: '/admin/roles'
    },
    {
      display: 'Repositories',
      link: '/admin/repositories'
    },
    {
      display: 'Policies',
      link: '/admin/policies'
    },
    {
      display: 'Site',
      link: '/admin/sites'
    },
    {
      display: 'Audits',
      link: '/admin/audits'
    },
  ];

  const managerNav = [
    {
      display: 'Users',
      link: '/admin/users'
    },
    {
      display: 'Roles',
      link: '/admin/roles'
    },
    {
      display: 'Repositories',
      link: '/admin/repositories'
    },
    {
      display: 'Site',
      link: '/admin/sites'
    },
    {
      display: 'Audits',
      link: '/admin/audits'
    },
  ];

  const managerOfUsersWithAuditsNav = [
    {
      display: 'Users',
      link: '/admin/users'
    },
    {
      display: 'Audits',
      link: '/admin/audits'
    },
  ];

  const managerOfUsersWithoutAuditsNav = [
    {
      display: 'Users',
      link: '/admin/users'
    },
  ];

  const navArray = () => {
    if (account.user.isAdmin) {
      return adminNav;
    }
    if (account.user.isManager) {
      return managerNav;
    }
    if (account.user.isManagerOfUsers && site.options.allowManagersOfUsersToViewAudits) {
      return managerOfUsersWithAuditsNav;
    }
    if (account.user.isManagerOfUsers && !site.options.allowManagersOfUsersToViewAudits) {
      return managerOfUsersWithoutAuditsNav;
    }
    return [];
  };

  return (
    <Card className={classes.searchbar} style={{ background: '#29307E', borderRadius: 0 }}>
      <Box className={classes.itemList}>
        {navArray().map((navItem) => (
          <NavLink
            key={navItem.display}
            activeClassName={classes.active}
            underline="none"
            className={classes.item}
            exact
            to={navItem.link}
          >
            <Typography>{navItem.display}</Typography>
          </NavLink>
        ))}
        <NavLink
          key="close"
          activeClassName={classes.active}
          underline="none"
          className={classes.item}
          exact
          to="/app/documents/dashboard"
        >
          <Tooltip title="Close">
            <CloseIcon style={{ color: 'white' }} />
          </Tooltip>
        </NavLink>
      </Box>
    </Card>

  );
}

export default NavBar;
